// Generated by pnpm generate:icons from sources.json. Do not edit.
export const boldIconVariants = {
  "agreement": "agreement-filled",
  "analytics": "analytics-filled",
  "api": "api-filled",
  "briefcase": "briefcase-filled",
  "building": "building-filled",
  "calendar": "calendar-filled",
  "chart-line": "chart-line-filled",
  "check-square": "check-square-filled",
  "city": "city-filled",
  "clipboard-clock": "clipboard-clock-filled",
  "clock": "clock-filled",
  "computer-dollar": "computer-dollar-filled",
  "credit-card": "credit-card-filled",
  "dashboard": "dashboard-filled",
  "database-import": "database-import-filled",
  "document": "document-filled",
  "document-attachment": "document-attachment-filled",
  "document-edit": "document-edit-filled",
  "download": "download-filled",
  "fingerprint": "fingerprint-filled",
  "folder": "folder-filled",
  "folder-library": "folder-library-filled",
  "globe": "globe-filled",
  "home": "home-filled",
  "inbox": "inbox-filled",
  "key": "key-filled",
  "mail-account": "mail-account-filled",
  "megaphone": "megaphone-filled",
  "money": "money-filled",
  "money-exchange": "money-exchange-filled",
  "note": "note-filled",
  "notification": "notification-filled",
  "office": "office-filled",
  "plug": "plug-filled",
  "pushpin": "pushpin-filled",
  "receipt": "receipt-filled",
  "receipt-dollar": "receipt-dollar-filled",
  "refresh": "refresh-filled",
  "send": "send-filled",
  "settings": "settings-filled",
  "shield-check": "shield-check-filled",
  "shield-user": "shield-user-filled",
  "star": "star-filled",
  "stop": "stop-filled",
  "swap-horizontal": "swap-horizontal-filled",
  "table": "table-filled",
  "target": "target-filled",
  "task": "task-filled",
  "user": "user-filled",
  "users": "users-filled",
  "users-group": "users-group-filled",
  "warning": "warning-filled",
  "web-protection": "web-protection-filled",
  "wrench": "wrench-filled",
  "users-three": "users-three-filled",
  "mail-document": "mail-document-filled",
  "users-two": "users-two-filled",
  "home-fun": "home-fun-filled",
  "board-menu": "board-menu-filled",
  "paper-curved": "paper-curved-filled",
  "board-pin": "board-pin-filled",
  "document-add": "document-add-filled",
  "repeat": "repeat-filled",
  "user-verify": "user-verify-filled",
  "board-tasks": "board-tasks-filled",
  "mail": "mail-filled",
  "mail-open": "mail-open-filled",
  "mail-send": "mail-send-filled",
  "mail-receive": "mail-receive-filled",
  "dollar-up": "dollar-up-filled",
  "card-wallet": "card-wallet-filled",
  "bank-card-share-money": "bank-card-share-money-filled",
  "cards": "cards-filled",
  "user-edit": "user-edit-filled",
  "user-settings": "user-settings-filled",
  "face-id-lock": "face-id-lock-filled",
  "wallet-menu": "wallet-menu-filled",
  "shield-done": "shield-done-filled",
  "cloud-download": "cloud-download-filled",
  "cashier": "cashier-filled",
  "target-search": "target-search-filled",
  "settings-gear": "settings-gear-filled",
  "sidebar-pin": "sidebar-pin-filled",
  "star-magic-glow": "star-magic-glow-filled",
  "ai-suggestion": "ai-suggestion-filled"
} as const;

export const bulkIconVariants = {
  "home": "home-bulk",
  "home-fun": "home-fun-bulk",
  "board-menu": "board-menu-bulk",
  "paper-curved": "paper-curved-bulk",
  "city": "city-bulk",
  "board-pin": "board-pin-bulk",
  "document-edit": "document-edit-bulk",
  "document-add": "document-add-bulk",
  "briefcase": "briefcase-bulk",
  "repeat": "repeat-bulk",
  "user-verify": "user-verify-bulk",
  "task": "task-bulk",
  "board-tasks": "board-tasks-bulk",
  "mail": "mail-bulk",
  "notification": "notification-bulk",
  "mail-open": "mail-open-bulk",
  "mail-send": "mail-send-bulk",
  "mail-receive": "mail-receive-bulk",
  "dollar-up": "dollar-up-bulk",
  "document": "document-bulk",
  "card-wallet": "card-wallet-bulk",
  "bank-card-share-money": "bank-card-share-money-bulk",
  "cards": "cards-bulk",
  "settings-gear": "settings-gear-bulk",
  "shield-user": "shield-user-bulk",
  "user-edit": "user-edit-bulk",
  "user-settings": "user-settings-bulk",
  "face-id-lock": "face-id-lock-bulk",
  "wallet-menu": "wallet-menu-bulk",
  "shield-done": "shield-done-bulk",
  "api": "api-bulk",
  "cloud-download": "cloud-download-bulk",
  "cashier": "cashier-bulk",
  "target-search": "target-search-bulk"
} as const;

// Active states prefer the real Bold drawing, then the real Bulk drawing.
export const filledIconVariants = { ...bulkIconVariants, ...boldIconVariants } as const;
